import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers, ResponseContentType } from '@angular/http';
import { ApplicationUrlSettings } from '../../settings/ApplicationUrlSettings';
import { UploadParams } from '../../admin-dashboard/batch-upload/batch-upload-table/batch-upload-table.component';
import { ReportLine } from '../../DataStructures/TripReport/TripReport';
import { Report } from '../../DataStructures/Report/Report';
import * as FileSaver from 'file-saver';
import { Trip } from '../../DataStructures/Trip/Trip';
import { AuthService } from '../auth-service/auth.service';

@Injectable()
export class FileService {

  reportLines: Array<ReportLine>;
  report: Report;
  trips: Array<Trip> = new Array<Trip>()

  constructor(private http: Http) {

  }

  registerDriver(data: FormData) {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.DRIVER;
    return this.http.post(url, data).toPromise().then(res => res.json());
  }

  generateCsv(body): Promise<string> {

    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.GENERATE_CSV;
    return this.http.post(url, body).toPromise().then(res => res.json());
  }

  exportUserData() {
    var clientid = AuthService.getClientId();
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.EXPORT_USERS}?clientid=${clientid}`;
    window.open(url);
  }

  condensedReport(start, end, dateField, companyid = null, locationid = null) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    var url = `${ApplicationUrlSettings.NODE_API_URL}report/trip-condensed?startDate=${start}&endDate=${end}&dateField=${dateField}`;
    if (companyid) {
      url += `&companyid=${companyid}`;
      if (locationid) {
        url += `&locationid=${locationid}`;
      }
    }
    this.http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).subscribe((res: any) => {
      const blob = new Blob([res._body], { type: res.headers.get('Content-Type') });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Condensed Report`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
  }

  expandedReport(start, end, dateField, companyid = null, locationid = null) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    var url = `${ApplicationUrlSettings.NODE_API_URL}report/trip-expanded?startDate=${start}&endDate=${end}&dateField=${dateField}`;
    if (companyid) {
      url += `&companyid=${companyid}`;
      if (locationid) {
        url += `&locationid=${locationid}`;
      }
    }
    this.http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).subscribe((res: any) => {
      const blob = new Blob([res._body], { type: res.headers.get('Content-Type') });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Expanded Report`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
  }
  condensedSurveyReport(start, end, dateField, companyid = null, locationid = null) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    var url = `${ApplicationUrlSettings.NODE_API_URL}report/trip-condensed-sureveyReport?startDate=${start}&endDate=${end}&dateField=${dateField}`;
    if (companyid) {
      url += `&companyid=${companyid}`;
      if (locationid) {
        url += `&locationid=${locationid}`;
      }
    }
    this.http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).subscribe((res: any) => {
      const blob = new Blob([res._body], { type: res.headers.get('Content-Type') });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Condensed Survey Report`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
  }
  downloadcsv(fileName: string) {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.DOWNLOAD_CSV + fileName;
    //window.open(url);
    this.http.get(url, { responseType: ResponseContentType.Blob }).subscribe((res: any) => {
      const blob = new Blob([res._body], { type: res.headers.get('Content-Type') });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${fileName}`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
  }

  downloadBuspass(userid) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.BUS_PAS}/${userid}`;
    return this.http.get(url, { responseType: ResponseContentType.Blob });
    //return this.http.get(url, { responseType: ResponseContentType.Blob }).map(res => res.blob());
  }

  csvStringToJson(csvStr: string) {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.CSV_TO_JSON;
    return this.http.post(url, { data: csvStr }).toPromise().then(res => res.json());
  }

  random(regions: any) {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.RANDOM;
    return this.http.post(url, regions).toPromise().then(res => res.json());
  }



  downloadPdfReport(body, template: string, fileName) {

    var postData = {
      "template": { "name": template },
      "data": body
    }

    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.PDF_REPORT;
    this.http.post(url, postData, { responseType: ResponseContentType.Blob }).toPromise().then((res: any) => {

      let blob = res.blob();
      FileSaver.saveAs(blob, fileName);
    }).catch(e => {
      alert("Error Downloading File: " + e);
    });
  }



  jsonToCSV(fields: Array<string>, content: any): Promise<string> {

    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.JSON_TO_CSV;
    var body = {
      fields: fields,
      content: content
    };
    return this.http.post(url, body).toPromise().then(res => res.json());
  }

  uploadcsv(params: UploadParams): Promise<any> {

    let _formData = new FormData();
    _formData.append("Name", "file");
    _formData.append("StartDate", params.weekRange.getStartDate());
    _formData.append("EndDate", params.weekRange.getEndDate());
    _formData.append("MyFile", params.file);
    _formData.append("locationid", params.locationid + "");
    _formData.append("companyid", params.companyid + "");
    let body = _formData;
    let headers = new Headers();
    let options = new RequestOptions({
      headers: headers
    });
    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.UPLOAD;
    return this.http.post(url, body, options).toPromise().then(res => res.json());
  }

  uploadUserFile(params: UploadParams) {
    let _formData = new FormData();
    _formData.append("MyFile", params.file);
    _formData.append("locationid", params.locationid + "");
    _formData.append("companyid", params.companyid + "");
    _formData.append("deptid", params.deptid + "");
    _formData.append("geocode", params.geocode + "");
    _formData.append("email", params.email + "");
    let body = _formData;
    let headers = new Headers();
    let options = new RequestOptions({
      headers: headers
    });
    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.REGISTER_USERS;
    return this.http.post(url, body, options).toPromise().then(res => res.json());
  }


  nodeUploadUserFile(params: UploadParams) {
    let _formData = new FormData();
    _formData.append("file", params.file);
    _formData.append("locationid", params.locationid + "");
    _formData.append("companyid", params.companyid + "");
    _formData.append("deptid", params.deptid + "");
    _formData.append("geocode", params.geocode + "");
    _formData.append("email", params.email + "");
    let body = _formData;
    let headers = new Headers();
    let options = new RequestOptions({
      headers: headers
    });
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.REGISTER_USERS_API;
    return this.http.post(url, body, options).toPromise().then(res => res.json());
  }
}
